import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Image } from 'react-bootstrap'
import { moreIcon } from '../../assets'

export default function AboutUsSection() {
    return (
        <div className='about-us-section d-flex flex-column align-items-start justify-content-center'>
            <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                <p align='left' style={{ fontWeight: '500', fontSize: '1.5em' }}>Stories become histories, but champions<br />
                    leave a legacy! Kaptain Ply began its quest for<br />
                    success during the economic boom in<br /> 2001.</p>
                <div className='more-about-us-button d-flex justify-content-center align-items-center'>
                    MORE ABOUT US
                    <Image src={moreIcon} className='mx-3' />
                </div>
            </AnimationOnScroll>
        </div>
    )
}
